import React, { useState } from "react";
import "../../Styles/TPOForm.css";

import AutonomousForm from "./RepresentativeAutonomousForm";
import UniversityForm from "./RepresentativeFormUniversity";
import BothForm from "./Both";

import ApiService from "../../nhrc_apis/ApiService";

const { MembershipAPI } = ApiService;

/* ✅ FIX: added memberId, membershipId */
function TPOForm({ personalData, onBackToPersonal, memberId, membershipId }) {

  const [selection, setSelection] = useState("");
  const [showNext, setShowNext] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [tpoId, setTpoId] = useState("");
  const [loading, setLoading] = useState(false);

  /* ---------------- ID ---------------- */
  const generateTpoId = () =>
    `NHRC-TPO-${Math.floor(1000 + Math.random() * 9000)}`;

  /* ---------------- VALIDATION ---------------- */
  const validateSelection = () => {
    if (!selection) {
      alert("Please select one option");
      return false;
    }
    return true;
  };

  /* ================= FINAL SUBMIT ================= */
  const handleFinalSubmit = async (instituteDetails) => {

    if (!instituteDetails) {
      alert("❌ Institute details missing");
      return;
    }

    if (!memberId || !membershipId) {
      alert("❌ Member/Membership ID missing");
      return;
    }

    try {
      setLoading(true);

      const id = generateTpoId();
      setTpoId(id);

      const payload = {
        tpo_id: id,
        role: "TPO",
        member_type: "representative",

        personal_details: personalData,
        institute_details: instituteDetails,

        created_at: new Date().toISOString(),
      };

      console.log("🔥 FINAL TPO PAYLOAD:", payload);

      let response;

      /* ================= API CALL ================= */
      if (selection === "University") {
        response = await MembershipAPI.representativeUniversity({
          member_id: memberId,
          membership_id: membershipId,
          ...instituteDetails
        });
      }

      else if (selection === "Autonomous") {
        response = await MembershipAPI.representativeAutonomous({
          member_id: memberId,
          membership_id: membershipId,
          ...instituteDetails
        });
      }

      else if (selection === "Both") {
        response = await MembershipAPI.representativeBoth({
          member_id: memberId,
          membership_id: membershipId,
          ...instituteDetails
        });
      }

      console.log("API RESPONSE:", response?.data);

      setShowPopup(true);

    } catch (err) {
      console.error("TPO ERROR:", err);
      alert(err?.response?.data?.detail || "❌ TPO API Failed");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- CHILD FORMS ---------------- */

  if (showNext && selection === "University") {
    return (
      <UniversityForm
        personalData={personalData}
        memberId={memberId}             // ✅ FIX
        membershipId={membershipId}     // ✅ FIX
        onBack={() => setShowNext(false)}
        onComplete={(data) => handleFinalSubmit(data)}  // ✅ FIX
      />
    );
  }

  if (showNext && selection === "Autonomous") {
    return (
      <AutonomousForm
        personalData={personalData}
        memberId={memberId}
        membershipId={membershipId}
        onBack={() => setShowNext(false)}
        onComplete={(data) => handleFinalSubmit(data)}
      />
    );
  }

  if (showNext && selection === "Both") {
    return (
      <BothForm
        personalData={personalData}
        memberId={memberId}
        membershipId={membershipId}
        onBack={() => setShowNext(false)}
        onComplete={(data) => handleFinalSubmit(data)}
      />
    );
  }

  /* ---------------- MAIN UI ---------------- */

  return (
    <div className="representative-wrapper">
      <div className="representative-card">

        <h5 className="title">REPRESENTATIVE DETAILS</h5>

        <form
          className="tpo-form-person"
          onSubmit={(e) => {
            e.preventDefault();

            if (loading) return;
            if (!validateSelection()) return;

            setShowNext(true);
          }}
        >

          <label className="tpo-label">
            University / Autonomous <span className="text-danger">*</span>
          </label>

          <select
            className="form-select"
            value={selection}
            onChange={(e) => setSelection(e.target.value)}
          >
            <option value="">Select One</option>
            <option value="University">University</option>
            <option value="Autonomous">Autonomous</option>
            <option value="Both">Both</option>
          </select>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn btn-success px-5"
              disabled={loading}
            >
              {loading ? "Processing..." : "Continue"}
            </button>
          </div>
        </form>

        <button
          className="btn btn-link mt-3"
          onClick={onBackToPersonal}
        >
          ← Back
        </button>
      </div>

      {/* ---------------- SUCCESS POPUP ---------------- */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <h2>🎉 TPO Registered Successfully</h2>

            <p><b>TPO ID:</b> {tpoId}</p>
            <p><b>Type:</b> {selection}</p>

            <button onClick={onBackToPersonal}>
              Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default TPOForm;